(function () {
  "use strict";

  function initRail(rail) {
    if (!rail || rail.dataset.jstSocialInitialized === "true") return;
    rail.dataset.jstSocialInitialized = "true";

    var toggle = rail.querySelector("[data-jst-social-toggle]");
    var desktop = window.matchMedia("(min-width: 768px)");
    var reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
    var footer = null;
    var frame = 0;
    var hidden = false;
    if (!toggle) return;

    function getFooter() {
      if (!footer || !document.documentElement.contains(footer)) {
        footer = document.querySelector(".jst-footer, footer[role='contentinfo'], footer");
      }
      return footer;
    }

    function setFooterHidden(nextHidden) {
      if (hidden === nextHidden) return;
      hidden = nextHidden;
      rail.classList.toggle("is-footer-hidden", hidden);

      if (hidden) {
        if (rail.contains(document.activeElement)) document.activeElement.blur();
        rail.setAttribute("aria-hidden", "true");
        rail.inert = true;
      } else {
        rail.removeAttribute("aria-hidden");
        rail.inert = false;
      }
    }

    function updateFooterFade() {
      frame = 0;
      var footerElement = getFooter();
      if (!footerElement) {
        setFooterHidden(false);
        return;
      }

      var viewport = Math.max(window.innerHeight || 0, 1);
      var footerTop = footerElement.getBoundingClientRect().top;
      var fadeStart = viewport * 1.4;
      var fadeEnd = viewport * 0.76;
      var progress = Math.min(1, Math.max(0, (fadeStart - footerTop) / (fadeStart - fadeEnd)));
      var direction = !desktop.matches && document.documentElement.dir === "rtl" ? 1 : -1;

      rail.style.setProperty("--rail-footer-opacity", (1 - progress).toFixed(3));
      rail.style.setProperty("--rail-footer-shift", reducedMotion.matches ? "0px" : (progress * direction * 22).toFixed(1) + "px");
      rail.style.setProperty("--rail-footer-scale", reducedMotion.matches ? "1" : (1 - progress * 0.06).toFixed(3));
      rail.style.setProperty("--rail-footer-blur", reducedMotion.matches ? "0px" : (progress * 4).toFixed(1) + "px");
      setFooterHidden(progress >= 0.995);

      if (progress > 0.55 && !desktop.matches && rail.classList.contains("is-open")) {
        setOpen(false);
      }
    }

    function scheduleFooterFade() {
      if (frame) return;
      frame = window.requestAnimationFrame(updateFooterFade);
    }

    function setOpen(open) {
      rail.classList.toggle("is-open", open);
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
    }

    function syncBreakpoint(event) {
      setOpen(event.matches);
    }

    setOpen(desktop.matches);
    toggle.addEventListener("click", function () {
      setOpen(!rail.classList.contains("is-open"));
    });

    toggle.addEventListener("keydown", function (event) {
      if (event.key !== "Enter" && event.key !== " ") return;
      event.preventDefault();
      setOpen(!rail.classList.contains("is-open"));
    });

    rail.addEventListener("keydown", function (event) {
      if (event.key !== "Escape" || desktop.matches) return;
      setOpen(false);
      toggle.focus();
    });

    if (desktop.addEventListener) desktop.addEventListener("change", syncBreakpoint);
    else desktop.addListener(syncBreakpoint);

    window.addEventListener("scroll", scheduleFooterFade, { passive: true });
    window.addEventListener("resize", scheduleFooterFade, { passive: true });
    document.addEventListener("shopify:section:load", function () {
      footer = null;
      scheduleFooterFade();
    });
    scheduleFooterFade();
  }

  function initAll(root) {
    (root || document).querySelectorAll("[data-jst-social-rail]").forEach(initRail);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { initAll(document); }, { once: true });
  } else {
    initAll(document);
  }

  document.addEventListener("shopify:section:load", function (event) { initAll(event.target); });
})();
